<template>
  <section class="skill" id="skills">
    <h1>My skillset</h1>

    <div class="spinerParent" v-if="loading">
      <img src="../assets/spinb.png" />
    </div>

    <fetchError :style="{display: fetchErr?'flex':'none'}" :Exception="fetchErr" />

    <div v-if="!loading && !(aFetchErr || fetchErr)" class="skillCont topDiv">

      <div class="plangCont">
        <!-- ======================================= -->
        <h2>Programming abilities</h2>

        <div class="spinerParent" v-if="aLoading" :style="{ margin: '25px 0 15px 0' }" >
          <img src="../assets/spinb.png" />
        </div>

        <div class="plang" id="skillResume" v-if="!aLoading" >
    
          <fetchError @ready="catchReady($event)" :style="{display: aFetchErr?'flex':'none', margin: '25px 0 15px 0'}" :Exception="aFetchErr" />

          <div class="strongest" v-for="(skill, i) in abilities" :id="`colorfull-${i}`" :key="i">
            
            <div class="blur">
              
              <div class="head">
                <img :src="skill.icon" class="skillIcon" :id="`colorimg-${i}`" />
                <h3 :style="{textAlign: 'start'}" >{{ skill.title }}</h3>
              </div>
            
              <div class="body">
                <p>{{ skill.shortDesc }}</p>
              </div>

              <div class="footer">
                <router-link :to="`/skillset/${skill.ref}`">See more</router-link>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="diving" v-if="technical.diving">
      <!-- ======================================= -->
        <h2>Things that I've been learning</h2>
        <div class="strCont">
          <div
            class="strongest"
            v-for="(skill, i) in technical.diving"
            :key="i"
            :style="{ justifyContent: 'unset' }"
          >
            <img :src="skill[0]" class="skillIcon" />
            <h3>{{ skill[1] }}</h3>
            <p>{{ skill[2] }}</p>
          </div>
        </div>
      </div>

      <p class="info">Have a look to my project's collection in the <router-link to="/projects">Projects section</router-link></p>

    </div>

    <div v-if="!loading && studies.done" class="skillCont">
      <div class="technical">
        <h2>Education</h2>
        <!-- ======================================= -->
        <div class="iconCont study" v-for="(Achievement, i) in studies.done" :key="i">
          <div>
            <img :src="Achievement[0]" class="skillIcon" />
            <p>{{ Achievement[1] }}</p> 
          </div>

          <div>
            <span>From {{Achievement[2]}}</span>
          </div>
        </div>
      </div>

      <div class="diving">
        <h2>Currently I am...</h2>
        <div
          class="iconCont study"
          v-for="(proceso, i) in studies.ongoing"
          :key="i"
        >

          <div>
            <img :src="proceso[0]" class="skillIcon" />
            <p>{{ proceso[1] }}</p> 
          </div>

          <div>
            <span>As {{proceso[2]}}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!loading && working.working" class="skillCont lastDiv">
      <div class="technical" :style="{minHeight: '310px'}">
        <!-- ======================================= -->
        <h2 id="carCarousel">Working characteristics</h2>

        <transition name="fade">
          <carousel-3d
            v-if="!loading && showCaracCarousel" 
            :count="working.working.length"
            :controls-visible="true"
            :perspective="15"
            :display="5"
            :loop="false"
            :width="220"
            :height="255"
            :border="0"
            :clickable="false"
            :animationSpeed="250"
            :autoplay="true"
            :autoplayTimeout="5000"
            :space="250"
          >
              <slide v-for="(skill, i) in working.working" v-bind:index="i" v-bind:key="i">
                  <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
                    <div :class="{ strongest_: 'strongest_', current: isCurrent, onLeft: (leftIndex > 0), onRight: (rightIndex > 0) }">
                      <img :src="skill[0]" class="skillIcon" />
                      <h3>{{ skill[1] }}</h3>
                      <p>{{ skill[2] }}</p>
                    </div>
                  </template>
              </slide>
          </carousel-3d>
        </transition>
      </div>

      <!-- ======================================= -->
      <h2>Personal characteristics</h2>
      <div class="strCont">
        <div class="strongest_" v-for="(skill, i) in working.social" :key="i">
          <img :src="working.social[i][0]" class="skillIcon" />
          <h3>{{ working.social[i][1] }}</h3>
          <p>{{ working.social[i][2] }}</p>
        </div>
      </div>

    </div>
    
  </section>
</template>

<script lang="js">
import Request from '../mixins/axiosRequest';
import { Carousel3d, Slide } from 'vue-carousel-3d';
import colorPalette from "../mixins/colorPaletteExtraction.js";
import fetchError from "./Small/fetchError.vue";

export default {
  name: "Skills",

  components: {
    Carousel3d,
    Slide,
    fetchError
  },
  data() {
    return {
      technical: {},
      working: {},
      studies: {},
      abilities: null,
      loading: true,
      showCaracCarousel: false,
      themeColors: {},
      fetchErr: null,
      aLoading: true,
      aFetchErr: null
    };
  },

  methods: {
    async getSkills() {
      let data = await Request.axiosGet("/api/skills", this.client);
      if(data.status) {
        this.technical = data.data[0].technical;
        this.working = data.data[0].working;
        this.studies = data.data[0].studies;
        this.addListenner();
        this.getAbilities();
      } else {
        this.fetchErr = data.data;
        this.aLoading = false;
      }
      this.loading = false;
    },
    async getAbilities() {
      let data = await Request.axiosGet("/api/ability", this.client);
      if(data.status) {
        this.abilities = data.data;
        if(data.data) {
          this.getSkillsCards();
        }
      } else {
        this.aFetchErr = data.data;
      }
      this.aLoading = false;
    },
    isInViewport() {
      let el = document.getElementById("carCarousel");
      if(el) {
        const rect = el.getBoundingClientRect();
        if(rect) {
          this.showCaracCarousel =  (
            rect.bottom <= (window.innerHeight -200 || document.documentElement.clientHeight -200) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          );
        }
      }
    },
    applyThematicColor(applyTo, selector) {
      document.querySelector(`#${applyTo}`).style.opacity = .5;
      
      colorPalette.extract(selector).then(Palette => {
        let avrgColor = Palette[0][Math.floor(Palette[0].length / 2)];
        let el = document.querySelector(`#${applyTo}`);

        this.themeColors[applyTo] = avrgColor;
        
        if(!el) return;

        el.style.transition = 'all 1s';
        el.style.background = `linear-gradient(transparent, ${avrgColor}4e)`;
        el.style.opacity = 1;
      }) 
    },
    getSkillsCards() {
      setTimeout(() => {
        let skills = document.querySelector("#skillResume");
        let iterableSkills = skills.getElementsByClassName("strongest");

        for (let item of iterableSkills) {
          let image = item.getElementsByTagName("img")[0];
          image.style.mixBlendMode = 'initial';
          //image.style.backgroundColor = "#000";
          this.applyThematicColor(item.id, image.id);
        }
      }, 800);
    },
    addListenner() {
      document.addEventListener('scroll', this.isInViewport, {passive:true});
    },
    removeListenner() {
      document.removeEventListener('scroll', this.isInViewport, {passive:true});
    },
    catchReady(evt) {
      if(evt && this.aFetchErr) {
        evt(this.aFetchErr.message , this.aFetchErr.name);
      }
    },
  },

  mounted() {
    this.loading = true;
    this.aLoading = true;

    this.getSkills();
  },

  destroyed() {
    this.removeListenner();
  }
};
</script>

<style scoped lang="scss">

@media (prefers-color-scheme: dark) {
  .skillCont {
    background-color: #00000044;
  }

}

@media (prefers-color-scheme: light) {
  .skillCont {
    background-color: #ffffff44;
  }
}

.topDiv {
  margin-top: 40px;
}

.carousel-3d-slide {
  background-color: transparent;
  cursor: default;
}

.right-1, .right-2 {
  opacity: 0.75 !important;
}
.right-2 {
  opacity: 0.5 !important;
}

.left-1, .left-2 {
  opacity: 0.75 !important;
}
.left-2 {
  opacity: 0.5 !important;
}

.plang {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* width: 80%; */
  margin: 0 0 25px 0;
}

.plang .strongest {
  opacity: 0.2;
  background: linear-gradient(#f1f1f134, #b0b0b0c5);
  border-bottom: 6px solid #000;
  width: 340px;
  height: auto;
  max-width: none;
  min-height: 225px;

  padding: 0px;

  overflow: hidden;

  .blur {
    background-color: rgba(255, 255, 255, 0.335);
    height: 100%;
    min-width: 340px;
    padding: 10px 0 5px 0;
    display: flex;
    flex-direction: column;
    align-items: baseline;
    justify-content: flex-start;

    .head {
      width: 100%;
      display: flex;
      align-items: center;
      height: 45%;
    }

    .body {
      width: 100%;
      margin-bottom: 25px;
      height: 30%;
      p {
        text-align: justify;
        padding: 10px 8px 0 8px;

      }
    }

    .footer {
      height: 30px;
      width: 98%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 15%;
      
      a {
        color: #000;
        font-weight: bold;
      }
    }
  }

}

.strongest {
  width: 180px;
  max-width: 180px;
  margin: 10px 10px;
  padding: 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: 5px solid rgb(0, 0, 0);
  box-shadow: 2px 0px 5px#5c5c5c;
  height: 210px;
  max-height: 210px;
  background: linear-gradient(#b0b0b087, #cecece);

  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}

.strongest h3 {
  margin: 2px 0 5px 0;
  color: rgb(0, 0, 0);
}

.strongest p {
  text-align: center;
  color: #000;
}


.plangCont {
  margin-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.technical {
  margin: 15px 0;
  height: auto;
}

.diving {
  margin: 15px 0;
}

.dbases {
  margin-bottom: 25px;
}

.skill {
  margin: 0px auto 0px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1366px;
  min-height: 575px;
  background: transparent;
  padding-bottom: 4em;
  padding-top: 5em;

}

.skillCont {
  border-radius: 5px;
  box-shadow: 0px 0px 5px #000000ab;
  width: 80%;
  height: auto;
  padding: 15px 30px;
  margin: 15px 0;
  transition: background-color .4s;

  .info {
    font-size: 17px;
    margin: 30px 0 15px 0;
    color: #000;

    a {
      background-color: rgb(0, 0, 0);
      color: rgb(255, 255, 255);
      font-weight: bold;
      padding: 2px 5px;
      font-size: 17px;
    }
  }
}

.lastDiv {
  padding-bottom: 40px;
}

h1 {
  letter-spacing: 3px;
  color: #000;
  text-align: center;
  width: 100%;
  cursor: default;
  font-size: 45px;
  margin: 0 0 20px 0;
}


.skillIcon {
  height: 100px;
  width: 100px;
  margin: 0 10px;
  border-radius: 50%;
  object-fit: cover;
  transition: opacity 0.7s;
}

h2 {
  cursor: default;
  margin-bottom: 15px;
  font-size: 30px;
  font-weight: 200;
  color: #000;
}

.iconCont {
  display: inline-flex;
  align-items: flex-start;
  flex-direction: column;
  margin: 10px 15px;

  max-width: 280px;
  min-width: 280px;
  border: 1px solid rgba(62, 62, 62, 0.376);
  border-left: 3px solid black;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.406);

  background: rgba(255, 255, 255, 0.3);

  p {
    cursor: default;
    font-weight: bold;
    font-size: 15px;
    transition: opacity 1s;
    text-align: left;
    color: #000;
    margin-top: 5px;
  }

  img {
    margin: 5px 10px 5px 5px;
    height: 60px;
    width: 60px;
  }

  div:first-child {
    display: flex;
    align-items: center;
  }

  div:nth-child(-n+2) {
    padding: 0 0px 7px 0px;
    color: #313131;
    font-size: 13px;
    width: 100%;
/*     display: flex;
    justify-content: center;
    align-items: center; */
  }
}

.study {
  justify-content: flex-start;
}

.study p {
  cursor: default;
  font-weight: bold;
  font-size: 16px;
}

.strCont {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.strongest_ {
  width: 180px;
  max-width: 180px;
  margin: 10px 10px;
  padding: 10px;
/*   border-bottom-left-radius: 5px; */
  border-top-left-radius: 5px;
/*   border-bottom-right-radius: 5px; */
  border-bottom: 5px solid #fff;
  border-top-right-radius: 5px;
  box-shadow: 2px 0px 5px#5c5c5c;
 /*  background: #202020db; */
  background: linear-gradient(to bottom,#2020201d, #1d1d1dd6);
  height: 210px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}


.strongest_ h3 {
  margin: 2px 0 5px 0;
  color: #fff;
}

.strongest__ h3 {
  margin: 2px 0 5px 0;
  color: #fff;
}


.strongest_ p {
  text-align: center;
  color: #fff;
}

.strongest__ p {
  text-align: center;
  color: #fff;
}

.plang .strongest h3 {
  margin: 2px 0 5px 0;
  color: #000;
}

.plang .strongest p {
  text-align: center;
  color: #000;
}

.spinerParent {
  margin: auto 0 auto 0;
} 

@media screen and (max-width: 780px) {
  .skillCont {
    width: 98%;
    padding: 10px 0px;
  }

  h1 {
    padding-top: 0px;
    top: 0;
    margin: 0;
  }

  h2 {
    font-size: 26px;
  }

  .skillIcon {
    height: 65px;
    width: 65px;
    margin: 0 15px;
  }

  .iconCont {
    max-width: 100px;
    justify-content: center;
    align-items: center;
  }

  .iconCont p {
    position: absolute;
    font-size: 17px;
    text-overflow: clip;
  }

  .study {
    max-width: 150px;
    flex-direction: column;
  }

  .study p {
    position: relative;
    font-size: 15px;
  }
}

@media screen and (max-width: 615px) {
  .skillCont {
    padding: 4px 4px;
  }

  h1 {
    font-size: 42px;
  }

  .skillIcon {
    height: 50px;
    width: 50px;
    margin: 0 12px;
  }

  .iconCont {
    margin: 7px 12px;
  }
}

@media screen and (max-width: 500px) {
  .skillCont {
    padding: 3px 3px;
  }

  h1 {
    font-size: 45px;
  }
}


  .fade-enter-active,
  .fade-leave-active {
      transition: opacity .3s
  }

  .fade-enter,
  .fade-leave-to {
      opacity: 0
  }
</style>